import React from "react";
import { Table } from "antd";

type TableColumn = {
  title: string;
  dataIndex: string;
  key: string;
  width?: number;
  render?: (text: any, record: any) => React.ReactNode;
};

type TableProps = {
  columns: TableColumn[];
  data: any[];
  loading?: boolean; // ✅ Added loading prop
  rowsPerPage?: number; // ✅ Added rowsPerPage prop (default 10)
  actions?: {
    label: React.ReactNode; // ✅ Fixed: Accepts string or JSX (icons)
    onClick: (record: any) => void;
    className?: string;
  }[];
};

const DynamicTable: React.FC<TableProps> = ({ columns, data, loading = false, rowsPerPage = 10, actions = [] }) => {
  const modifiedColumns: TableColumn[] = [
    ...columns.map((col) => ({ ...col, width: col.width || 200 })), // Ensuring column width
    ...(actions.length > 0
      ? [
          {
            title: "Action",
            dataIndex: "action",
            key: "action",
            width: 200, // Fixed width for action column
            render: (_, record) => (
              <div className="flex space-x-2">
                {actions.map((action, index) => (
                  <span
                    key={index}
                    className={`cursor-pointer ${action.className || "text-blue-500"}`}
                    onClick={() => action.onClick(record)}
                  >
                    {action.label}  {/* ✅ Now supports icons too */}
                  </span>
                ))}
              </div>
            ),
          },
        ]
      : []), // ✅ Agar actions empty hai toh kuch bhi add nahi hoga
  ].filter(Boolean);

  return (
    <div className="w-full overflow-hidden "> {/* Prevents page overflow */}
      <div className="overflow-x-auto"> {/* Enables scrolling only for the table */}
        <Table
          columns={modifiedColumns}
          dataSource={data}
          pagination={{ pageSize: rowsPerPage }} // ✅ Rows per page dynamic
          scroll={{ x: "max-content" }} // Ensures only table scrolls, not the page
          loading={loading} // ✅ Added loading prop to Ant Design Table
        />
      </div>
    </div>
  );
};

export default DynamicTable;
